import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default (overrideClasses?: any) =>
  createStyles({
    container: {
      marginBottom: 24,
      boxShadow: '0 2px 4px 0 rgb(0 0 0 / 20%)',
      '& .MuiCardHeader-root': {
        padding: '6px 10px',
      },
    },
    FormContainer: {
      display: 'flex',
      paddingLeft: 65,
      marginBottom: 24,
      alignItems: 'center',
    },
    textFieldContainer: {
      display: 'flex',
      alignItems: 'baseline',
      width: '100%',
      maxWidth: '98%',
    },
    switchChecked: {
      '&.Mui-checked': {
        color: palette.green,

        '& + .MuiSwitch-track': {
          backgroundColor: palette.green,
        },
      },
    },
    subtitle: {
      fontSize: 12,
      fontWeight: 500,
    },
    switchSpace: { marginTop: 5 },
    cardTitle: { marginBottom: 10 },
    ...overrideClasses,
  });
